import React, { useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Page from "../../../components/Page";
import CoachingServicesListing from "../../../components/NewDesign/Halifax/Coaching/Listing/CoachingServicesListing";

const CoachingServices = () => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <Page>
        <Loader start={isLoading} />
        <CoachingServicesListing
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </Page>
    </>
  );
};

export default CoachingServices;
